<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="barImage"
    :permanent="$vuetify.breakpoint.mdAndUp"
    mobile-break-point="960"
    app
    width="260"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img :gradient="`to bottom, ${barColor}`" v-bind="props" />
    </template>

    <v-list-item @click="goPanel" class="pa-0 ma-0" two-line>
      <v-list-item-content class="pa-0 ma-0">
        <v-list-item-title
          class="text-uppercase font-weight-regular display-2 pa-0 ma-0 px-8"
        >
          <v-img
            class="pa-0 ma-0 mx-auto"
            src="@/assets/logoFunEatsBlanco.svg"
            aspect-ratio="1.7"
            height="80"
            contain
          ></v-img>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider class="" />

    <v-list class="text-center" dense nav>
      <h3>
        {{
          this.roleObj
            ? this.roleObj.value == 'boss_negocio'
              ? this.$store.state.app.negocioObjGest.nombre
              : this.roleObj.text
            : '-'
        }}
        <span v-if="roleObj.value == 'partner'">{{
          $store.state.app.partner.nombre
        }}</span>
      </h3>
    </v-list>
    <v-divider class="" />

    <!-- <v-list dense nav>
      <base-item-group :item="profile" />
    </v-list>

    <v-divider class="" /> -->

    <v-list class="" expand nav>
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
      <v-autocomplete
        class=""
        v-if="roleObj.value == 'admin'"
        :items="negociosGestArray"
        v-model="negocio"
        :label="labelSelect"
      >
        <template slot="item" slot-scope="data">
          <!-- Divider and Header-->

          <v-list-item-content>
            <v-list-item-title v-html="data.item.text" />
            <v-list-item-subtitle v-html="data.item.tipo" />
          </v-list-item-content>
        </template>
      </v-autocomplete>
      <v-select
        v-if="roleObj.value == 'boss_restaurante'"
        :items="restaurantesGestArray"
        v-model="restaurante"
        item-text="nombre"
        item-value="id"
        multiple
        label="Restaurante"
      ></v-select>
      <template v-for="(item, i) in menuByRol()">
        <base-item-group v-if="item.children" :key="`group-${i}`" :item="item">
        </base-item-group>

        <base-item v-else :key="`item-${i}`" :item="item" />
      </template>

      <v-list-item @click="logout">
        <v-list-item-avatar>
          <v-icon>mdi-logout</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>Logout</v-list-item-title>
          <v-list-item-subtitle>Hasta la próxima</v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          <v-btn icon>
            <v-icon color="grey lighten-1">mdi-bye</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <div />
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import { mapState, mapGetters } from 'vuex';
  import { goPanel } from '@/utils/router.js';

  export default {
    name: 'DashboardCoreDrawer',

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({}),

    computed: {
      labelSelect() {
        return 'Negocio o Directorio';
      },
      ...mapState(['barColor', 'barImage']),
      ...mapState({
        negociosGestArrayBruto: (state) => state.app.negociosGestArray,
        directorios: (state) => state.directorios.directorios,
        restaurantesGestArray: (state) => state.app.restaurantesArray,
        negocioGest: (state) => state.app.negocioGest,
        user: (state) => state.auth.user,
      }),
      negociosGestArray() {
        return [
          {
            header: 'NEGOCIOS',
          },
          ...this.negociosGestArrayBruto.map((n) => {
            return {
              ...n,
              tipo: 'Negocio',
            };
          }),
          {
            header: 'DIRECTORIOS',
          },
          ...this.directorios.map((d) => {
            return {
              text: d.nombre,
              value: 'directorio_' + d.id,
              tipo: 'Directorio',
            };
          }),
        ];
      },
      ...mapGetters({
        negocioGestSlug: 'app/negocioGestObj',
        numPedidosGlobales: 'pedidos/numeroPedidos',
        numAlertas: 'alertas/getAlertasCount',
        roleObj: 'auth/roleObj',
      }),
      negocio: {
        get() {
          return this.$store.state.app.negocioGest
            ? this.$store.state.app.negocioGest
            : this.$store.state.app.directorioGest
            ? 'directorio_' + this.$store.state.app.directorioGest
            : null;
        },
        set(item) {
          let iDir = item.indexOf('directorio_');
          if (iDir > -1) {
            let id = item.replace('directorio_', '');
            this.$store.commit('app/setNegocioGest', null);
            this.$store.commit('app/setDirectorioGest', id);

            this.initDirectorio().then(() => {
              this.$router.push('/admin/directorio/' + id + '/configuracion');
              this.$forceUpdate();
            });
            return;
          } else {
            this.$store.commit('app/setNegocioGest', item);
            this.$store.commit('app/setDirectorioGest', null);

            this.initNegocio().then(() => {
              this.$router.push(
                '/admin/gest/' + this.negocioGestSlug.id + '/restaurantes'
              );
            });
          }
        },
      },
      restaurante: {
        get() {
          return this.$store.state.app.restauranteGest
            ? this.$store.state.app.restauranteGest
            : null;
        },
        set(item) {
          this.$store.commit('app/setRestauranteGest', item);
          /*this.$router.push(
          "/admin/gest/" + this.negocioGestSlug.id + "/restaurantes"
        );*/
          //this.initNegocio();
        },
      },
      drawer: {
        get() {
          return this.$store.state.drawer;
        },
        set(val) {
          this.$store.commit('SET_DRAWER', val);
        },
      },
      profile() {
        return {
          //avatar: true,
          group: '',
          title: this.user.displayName,
          /*children: [
          {
            to: "",
            title: this.$t("edit-profile")
          }
        ]*/
        };
      },
    },

    watch: {
      '$vuetify.breakpoint.smAndDown'(val) {
        this.$emit('update:expandOnHover', !val);
      },
    },

    methods: {
      menuByRol() {
        switch (this.roleObj.value) {
          case 'admin':
            return this.computedItems().filter((c) => {
              return (
                !c.visibleIf ||
                (c.visibleIf == 'negocio' &&
                  !!this.$store.state.app.negocioGest) ||
                (c.visibleIf == 'directorio' &&
                  !!this.$store.state.app.directorioGest)
              );
            });
            break;
          case 'boss_negocio':
            return this.menuBossNegocio();
            break;
          case 'boss_restaurante':
            return this.menuBossRestaurante();
            break;
          case 'boss_directorio':
            return this.menuBossDirectorio();
            break;
          case 'partner':
            return this.menuPartner();
            break;
        }
      },
      goPanel() {
        this.$router.push(goPanel());
      },
      menuBossNegocio() {
        let items = [
          {
            icon: 'mdi-view-dashboard',
            title: 'nav.portada',
            to: '/admin/negocio/panel',
          },
          // {
          //   icon: "mdi-account",
          //   title: "nav.clientes",
          //   to: "/admin/negocio/clientes",
          // },
          // {
          //   icon: "mdi-shopping",
          //   title: "nav.pedidos",
          //   to: "/admin/negocio/pedidos",
          // },
          // {
          //   icon: "mdi-store",
          //   title: "nav.restaurantes",
          //   to: "/admin/negocio/restaurantes",
          // },
          // {
          //   icon: "mdi-food",
          //   title: "nav.productos",
          //   to: "/admin/negocio/productos",
          // },
          {
            icon: 'mdi-credit-card-multiple',
            title: 'nav.zcierres',
            to: '/admin/negocio/zcierres',
          },
          {
            icon: 'mdi-backup-restore',
            title: 'nav.historialpedidos',
            to: '/admin/negocio/historialpedidos',
          },
          {
            icon: 'mdi-file-excel',
            title: 'nav.estadisticas',
            to: '/admin/negocio/estadisticas',
          },
          {
            icon: 'mdi-file-pdf',
            title: 'nav.contratos',
            to: '/admin/negocio/contratos',
          },
          // {
          //   icon: "mdi-archive",
          //   title: "nav.contabilidad",
          //   to: "/admin/negocio/contabilidad",
          // },
          {
            icon: 'mdi-currency-eur',
            title: 'nav.facturacion',
            to: '/admin/negocio/facturacion',
          },
          {
            group: '/admin/negocio/internos',
            //icon: "mdi-book-multiple",
            icon: 'mdi-newspaper',
            title: 'nav.internos',
            children: [
              {
                title: 'nav.internos.pedidos',
                to: 'listado',
              },
              {
                title: 'nav.internos.productos',
                to: 'productos',
              },
              {
                title: 'nav.internos.categorias',
                to: 'categorias',
              },
            ],
          },
          {
            icon: 'mdi-alert-circle',
            title: 'nav.notificaciones',
            to: '/admin/negocio/notificaciones',
          },
          {
            icon: 'mdi-newspaper-variant',
            title: 'nav.noticias',
            to: '/admin/negocio/noticias',
          },
        ];
        return items.map(this.mapItem);
      },
      menuPartner() {
        let items = [
          {
            icon: 'mdi-view-dashboard',
            title: 'nav.portada',
            to: '/admin/partner/panel',
          },
          {
            icon: 'mdi-file-pdf',
            title: 'nav.contratos',
            to: '/admin/partner/contratos',
          },
          {
            icon: 'mdi-currency-eur',
            title: 'nav.facturacion',
            to: '/admin/partner/facturacion',
          },
          // {
          //   icon: "mdi-content-paste",
          //   title: "nav.comisiones",
          //   to: "/admin/partner/comisiones",
          // },
        ];
        return items.map(this.mapItem);
      },
      menuBossDirectorio() {
        let items = [
          {
            icon: 'mdi-view-dashboard',
            title: 'nav.portada',
            to: '/admin/directorio/panel',
          },
          {
            icon: 'mdi-file-pdf',
            title: 'nav.contratos',
            to: '/admin/directorio/contratos',
          },
          {
            icon: 'mdi-currency-eur',
            title: 'nav.facturacion',
            to: '/admin/directorio/facturacion',
          },
          {
            icon: 'mdi-backup-restore',
            title: 'nav.historialpedidos',
            to: '/admin/directorio/historialpedidos',
          },
          {
            icon: 'mdi-chart-areaspline',
            title: 'nav.estadisticas',
            to: '/admin/directorio/estadisticas',
          },
        ];
        return items.map(this.mapItem);
      },
      menuBossRestaurante() {
        let items = [
          {
            icon: 'mdi-view-dashboard',
            title: 'nav.portada',
            to: '/admin/rest/panel',
          },
          {
            icon: 'mdi-account',
            title: 'nav.clientes',
            to: '/admin/rest/clientes',
          },
          {
            icon: 'mdi-shopping',
            title: 'nav.pedidos',
            to: '/admin/rest/pedidos',
          },
          {
            icon: 'mdi-file-excel',
            title: 'nav.estadisticas',
            to: '/admin/rest/stats',
          },
          {
            icon: 'mdi-file-pdf',
            title: 'nav.contratos',
            to: '/admin/rest/contratos',
          },
          {
            icon: 'mdi-currency-eur',
            title: 'nav.facturacion',
            to: '/admin/rest/facturacion',
          },
          {
            icon: 'mdi-newspaper',
            title: 'nav.internos',
            to: '/admin/rest/internos',
          },
        ];
        return items.map(this.mapItem);
      },
      // Menu drawer superUsuario
      computedItems() {
        let items = [
          {
            group: '/admin/gest/' + this.negocioGestSlug.id + '/almacen',
            icon: 'mdi-truck-fast-outline',
            title: 'nav.almacen',
            visibleIf: 'negocio',
            children: [
              {
                title: 'nav.almacen.tarifas',
                to: 'tarifas',
              },
              {
                title: 'nav.almacen.productos',
                to: 'productos',
              },
              {
                title: 'nav.almacen.categorias',
                to: 'categorias',
              },
              {
                title: 'nav.almacen.menus',
                to: 'menus',
              },
              {
                title: 'nav.almacen.modificadores',
                to: 'modificadores',
              },
              {
                title: 'nav.almacen.gruposmodificadores',
                to: 'gruposmodificadores',
              },
            ],
          },
          {
            title: 'nav.web',
            to: '/admin/gest/' + this.negocioGestSlug.id + '/web',
            visibleIf: 'negocio',
            icon: 'mdi-web-box',
          },
          {
            group: '/admin/gest/' + this.negocioGestSlug.id,
            icon: 'mdi-card-account-details-outline',
            title: 'nav.negocio',
            visibleIf: 'negocio',
            role: ['admin'],
            children: [
              {
                title: 'nav.restaurantes',
                to: 'restaurantes',
              },
              {
                title: 'nav.clientes',
                to: 'clientes',
              },

              {
                title: 'nav.productoscruzados',
                to: 'productoscruzados',
              },
              {
                title: 'nav.carta',
                to: 'carta',
              },
              {
                title: 'nav.descuentos',
                to: 'descuentos',
              },
              {
                title: 'nav.cupones',
                to: 'cupones',
              },
              {
                title: 'nav.totems',
                to: 'totems',
              },

              {
                title: 'nav.tickets',
                to: 'tickets',
              },
              {
                title: 'nav.mapeo',
                to: 'mapeo',
              },
              {
                title: 'nav.vromo',
                to: 'vromo',
              },
              // {
              // title: "nav.notificaciones",
              // to: "notificaciones",
              // },
              {
                title: 'nav.noticias',
                to: 'noticias',
              },

              {
                title: 'nav.integraciones',
                to: 'integraciones',
              },
            ],
          },
          {
            group: '/admin/gest/' + this.negocioGestSlug.id + '/internos',
            icon: 'mdi-basket-outline',
            title: 'nav.internos',
            visibleIf: 'negocio',
            children: [
              {
                title: 'nav.internos.productos',
                to: 'productos',
              },
              {
                title: 'nav.internos.categorias',
                to: 'categorias',
              },
              {
                title: 'nav.internos.pedidos',
                to: 'internos-pedidos',
              },
            ],
          },
          {
            icon: 'mdi-view-dashboard',
            title: 'nav.portada',
            to: '/admin/panel',
          },
          {
            group: '/admin/directorio/' + this.$store.state.app.directorioGest,
            icon: 'mdi-image',
            title: 'nav.directorio',
            visibleIf: 'directorio',
            role: ['admin'],
            children: [
              {
                title: 'nav.configuracion',
                to: 'configuracion',
              },
              {
                title: 'nav.web',
                to: 'web',
              },
            ],
          },
          {
            group: '/alertas',
            icon: 'mdi-alert',
            to: '/admin/alertas',
            title: 'nav.alertas',
            badge: this.numAlertas,
          },
          {
            group: '/pedidos',
            icon: 'mdi-shopping',
            to: '/admin/pedidos',
            title: 'nav.pedidos',
            badge: this.numPedidosGlobales,
          },
          {
            icon: 'mdi-face-agent',
            href: 'https://mewosystems.freshdesk.com/a/dashboard/default',
            title: 'nav.freshdesk',
            badge: this.$store.getters['soporte/numeroTickets'],
          },
          {
            group: '/admin',
            icon: 'mdi-handshake-outline',
            title: 'nav.newclientes',
            children: [
              {
                title: 'nav.negocios',
                to: 'negocios',
              },
              {
                title: 'nav.directorios',
                to: 'directorios',
              },
              {
                title: 'nav.partners',
                to: 'partners',
              },
            ],
          },
          {
            group: '/admin',
            icon: 'mdi-chart-areaspline',
            title: 'nav.stats',
            children: [
              {
                to: 'estadisticas-bq',
                title: 'nav.estadisticas',
              },
              {
                to: 'estadisticas',
                title: 'nav.historialpedidos',
              },
            ],
          },

          /*{
          icon: "mdi-google",
          title: "nav.estadisticas",
          href: "https://datastudio.google.com/reporting/4240e4c2-0b88-457c-b70e-c32a83e72f32",
        },*/

          {
            group: '/admin',
            icon: 'mdi-attachment',
            title: 'nav.admin',
            children: [
              {
                title: 'nav.facturacion',
                to: 'facturacion',
              },
              {
                title: 'nav.usuarios',
                to: 'usuarios',
              },

              {
                title: 'nav.contratos',
                to: 'contratos',
              },
              {
                title: 'nav.caracteristicas',
                to: 'caracteristicas',
              },
              {
                title: 'nav.cocinas',
                to: 'cocinas',
              },
              {
                title: 'nav.impuestos',
                to: 'impuestos',
              },
            ],
          },
          {
            icon: 'mdi-database',
            title: 'nav.backup',
            to: '/admin/backup',
          },
        ];
        return items.map(this.mapItem);
      },
      mapItem(item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: this.$t(item.title),
        };
      },
      logout() {
        this.$store.dispatch('auth/firebaseLogout').then((r) => {
          this.$router.push('/login');
        });
      },
      initDirectorio() {
        return this.$store.dispatch('loading/getDirectorio');
      },
      initNegocio() {
        return this.$store.dispatch('loading/getNegocio');
      },
    },
    mounted() {
      console.log('vamos a obtener tickets');
      this.$store.dispatch('soporte/getTicketsAbiertosFreshdesk');
    },
  };
</script>
<style scoped>
  .borderB {
  border: 1px solid #fff;
}
</style>
